import { format, isWithinInterval, startOfMonth, endOfMonth, subMonths } from "date-fns";
import { fr } from "date-fns/locale";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ReturnCard } from "./ReturnCard";
import { useState } from "react";

interface TransactionGridProps {
  transactions: any[];
  isLoading: boolean;
}

export const TransactionGrid = ({ transactions, isLoading }: TransactionGridProps) => {
  const [selectedMonth, setSelectedMonth] = useState<string>("all");

  // Generate options for the last 24 months
  const monthOptions = Array.from({ length: 24 }, (_, i) => {
    const date = subMonths(new Date(), i);
    return {
      value: format(date, "yyyy-MM"),
      label: format(date, "MMMM yyyy", { locale: fr }),
    };
  });

  if (isLoading) {
    return <div className="text-center p-4">Chargement...</div>;
  }

  if (!transactions || transactions.length === 0) {
    return <div className="text-center p-4 text-gray-500">Aucune transaction trouvée</div>;
  }

  // Filter transactions based on selected month
  const filteredTransactions = selectedMonth === "all"
    ? transactions
    : transactions.filter(transaction => {
        const transactionDate = new Date(transaction.created_at);
        const [year, month] = selectedMonth.split("-");
        const startDate = startOfMonth(new Date(parseInt(year), parseInt(month) - 1));
        const endDate = endOfMonth(startDate);
        
        return isWithinInterval(transactionDate, { start: startDate, end: endDate });
      });

  // Group transactions by date
  const groupedTransactions = filteredTransactions.reduce((groups: any, transaction: any) => {
    const date = format(new Date(transaction.created_at), 'PP', { locale: fr });
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(transaction);
    return groups;
  }, {});

  return (
    <div className="space-y-6">
      <div className="mb-6">
        <Select
          value={selectedMonth}
          onValueChange={setSelectedMonth}
        >
          <SelectTrigger className="w-[200px]">
            <SelectValue placeholder="Filtrer par mois" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les mois</SelectItem>
            {monthOptions.map((month) => (
              <SelectItem key={month.value} value={month.value}>
                {month.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {Object.entries(groupedTransactions).map(([date, dateTransactions]: [string, any[]]) => (
        <div key={date} className="space-y-4">
          <h3 className="text-sm md:text-base font-medium text-gray-500">{date}</h3>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {dateTransactions.map((transaction: any) => (
              <ReturnCard key={transaction.id} transaction={transaction} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};